import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { Edit, Clone, Delete } from 'components/Icons';
import { Actions } from 'types/Table';

import {
  TableActions as TableActionsStyles,
  Dot,
  Dots,
  ActionsWrapper,
  ActionsItem,
  ActionsItemIcon,
  ActionsItemText,
} from './CellActionsStyled';

type Props = {
  onClick: (action: Actions, row: any) => void;
  row: any;
};

export const CellActions: React.FC<Props> = ({ onClick, row }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleClick = (action: Actions) => {
    onClick(action, row);
    setShowMenu(false);
  };

  return (
    <TableActionsStyles>
      <OutsideClickHandler
        onOutsideClick={() => showMenu && setShowMenu(false)}
      >
        <Dots onClick={() => setShowMenu(!showMenu)}>
          <Dot />
          <Dot />
          <Dot />
        </Dots>
        {showMenu && (
          <ActionsWrapper>
            <ActionsItem onClick={() => handleClick(Actions.Edit)}>
              <ActionsItemIcon>
                <Edit size='14px' fill='#0076C0' />
              </ActionsItemIcon>
              <ActionsItemText>{Actions.Edit}</ActionsItemText>
            </ActionsItem>
            <ActionsItem onClick={() => handleClick(Actions.Clone)}>
              <ActionsItemIcon>
                <Clone size='14px' fill='#0076C0' />
              </ActionsItemIcon>
              <ActionsItemText>{Actions.Clone}</ActionsItemText>
            </ActionsItem>
            <ActionsItem onClick={() => handleClick(Actions.Delete)}>
              <ActionsItemIcon>
                <Delete size='14px' fill='#0076C0' />
              </ActionsItemIcon>
              <ActionsItemText>{Actions.Delete}</ActionsItemText>
            </ActionsItem>
          </ActionsWrapper>
        )}
      </OutsideClickHandler>
    </TableActionsStyles>
  );
};
